(function($, Drupal) {
  Drupal.behaviors.pager_duplicate = {
    attach: function(context, settings) {
      if ($('.pager__item--last').length) {
        let $href = $('.pager__item--last').find('a').attr('href');
        if (!$('a[href*="' + $href + '"]').first().parent().hasClass('pager__item--last')) {
          $('a[href*="' + $href + '"]').first().parent().once('remove-duplicate').remove();
        }
      }
    }
  };
})(jQuery, Drupal);
